import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { BodyRouteParamsRequest } from '#models';
import type { ChatroomDataObject } from '#models/services';
import { routes } from '#routes';

type AddMemberChatroomRequest =
  paths['/chatrooms/{chatroomId}/members']['post']['requestBody']['content']['application/json'];
type AddMemberChatroomRouteParameters = paths['/chatrooms/{chatroomId}/members']['post']['parameters']['path'];

export const addMemberToChatroom = async ({
  body,
  routeParams: { chatroomId },
}: BodyRouteParamsRequest<AddMemberChatroomRequest, AddMemberChatroomRouteParameters>) =>
  getNodeApiAxiosInstance().post<ChatroomDataObject, AxiosResponse<ChatroomDataObject>>(
    routes.chatrooms.members.add(chatroomId),
    body,
  );
